<div class="py-4">
  <mat-card class="px-3">
    <mat-card-header>
      <div class="flex flex-row justify-content-between w-full mt-3">
        <shared-title class="flex justify-content-start mb-3 mb-1"
          >Acciones Asignadas</shared-title
        >
        <div class="gap-3 flex flex-row justify-content-end align-items-center">
          <shared-search-field
            (inputValue)="fielInput = $event"
            [data]="dataSource" />
          <shared-button
            (click)="modalAction()"
            class="mb-4"
            [typeBtn]="'button'"
            [color]="'accent'"
            [icon]="'add'"
            >Agregar
          </shared-button>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <div class="shadow-2 overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort>
          <!-- Position Column -->
          <ng-container matColumnDef="name" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
            <td mat-cell *matCellDef="let element">
              {{ element.code | uppercase }}
            </td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Descripción
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
            <td mat-cell *matCellDef="let element">{{ element.type }}</td>
          </ng-container>

          <ng-container matColumnDef="options" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                color="accent"
                [matMenuTriggerFor]="menu"
                aria-label="Mas opciones">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <a mat-menu-item>
                  <mat-icon mat-icon-button (click)="modalAction(element)"
                    >edit</mat-icon
                  >
                  <span>Editar</span>
                </a>
                <a mat-menu-item>
                  <mat-icon
                    mat-icon-button
                    (click)="modalAction(element)"
                    color="warn"
                    >delete</mat-icon
                  >
                  <span>Eliminar</span>
                </a>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">
              No hay resultados para la busqueda: {{ fielInput }}
            </td>
          </tr>
        </table>
      </div>
      <br />
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
